import type { ComputedRef, InjectionKey, WritableComputedRef } from 'vue'

export interface LtPaginationContext {
  currentPage?: WritableComputedRef<number>
  pageCount?: ComputedRef<number>
  disabled?: ComputedRef<boolean>
  changeEvent?: (val: number) => void
  handleSizeChange?: (val: number) => void
}

export const ltPaginationKey: InjectionKey<LtPaginationContext> =
  Symbol('ltPaginationKey')
